module.exports = __webpack_public_path__ + "img/dach_2.b68eddbf.webp";